<template>
  <span>
    <FontAwesomeIcon class="busy-indicator" icon="spinner" />
  </span>
</template>

<script lang="ts" setup>
/* ... */
</script>

<style lang="scss" scoped>
.busy-indicator {
  animation: rotation 800ms linear infinite;

  @keyframes rotation {
    from {
      transform: rotateZ(0deg);
    }

    to {
      transform: rotateZ(360deg);
    }
  }
}
</style>
